import type {ReactNode} from 'react';
import Head from 'next/head';
import {Box} from '@tempo/core';

import {AppHeader} from './common/AppHeader';
import {Footer} from './landing/Footer';

type Props = {
	children?: ReactNode;
	withHeader?: boolean;
	withFooter?: boolean;
};

export const Layout = ({
	children,
	withHeader = true,
	withFooter = true,
}: Props) => (
	<>
		<Head>
			<meta charSet="utf-8" />
			<meta name="viewport" content="initial-scale=1.0, width=device-width" />
		</Head>
		<Box
			minH="100vh"
			display="flex"
			flexDirection="column"
			bg="background.neutral.primary.default"
			color="text.neutral.primary.default"
		>
			{withHeader && <AppHeader />}
			<Box as="main" flex="1" display="flex" flexDirection="column">
				{children}
			</Box>
			{withFooter && <Footer />}
		</Box>
	</>
);
